import { render, staticRenderFns } from "./knowledge-base-category.vue?vue&type=template&id=9a9ab5e2&"
import script from "./knowledge-base-category.vue?vue&type=script&lang=js&"
export * from "./knowledge-base-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports